// extracted by mini-css-extract-plugin
export default {"button":"styles_button__UoQGF","focus":"styles_focus__-CD95"};